import React, { Component } from 'react';
import TarjetaSinopsis from '../Miscelanea/TarjetaSinopsis';
import BotonDeslizador from '../Miscelanea/BotonDeslizador';
import './Recomendados.css';

const IZQUIERDA = 1;
const DERECHA = 2;

class Recomendados extends Component {

    constructor(props) {
        super(props);
        this.state = {
            posicionDeslizamiento: 0,
            estaSeleccionado: false,
            posicionInicioSeleccion: {
                x: 0,
                y: 0
            },
            mostrarDeslizadorIzquierdo: false,
            mostrarDeslizadorDerecho: true
         };
        this.carrusel = React.createRef();
        this.tarjetaSeleccionada = React.createRef();
        this.deslizar = this.deslizar.bind(this);

        // Permite establecer cuando se realiza un arrastre
        this.manejarSeleccion = this.manejarSeleccion.bind(this);
        this.manejarMovimiento = this.manejarMovimiento.bind(this);
        this.manejarDeseleccion = this.manejarDeseleccion.bind(this);

    }

    // Permite establecer y decidir cuando se realiza un arrastre
    manejarSeleccion(ev) {
        this.setState({ estaSeleccionado: true, posicionInicioSeleccion: { x: ev.clientX, y: ev.clientY } });
    }
    manejarMovimiento(ev) {

        // Si entra aquí es porque obviamente se está moviendo :v
        // Ahora, solo me interesa saber si antes ya hubo un arrastre para manejarlo como tal
        if (this.state.estaSeleccionado) {
            console.log('esta arrastrando')
            // Para determinar la dirección, debo preguntar a qué distancia lo he arrastreo desde el inicio
            if (ev.clientX > this.state.posicionInicioSeleccion.x) {
                this.deslizar(IZQUIERDA, Math.abs(ev.clientX - this.state.posicionInicioSeleccion.x))
            } else {
                this.deslizar(DERECHA, Math.abs(ev.clientX - this.state.posicionInicioSeleccion.x))

            }
        }


    }
    manejarDeseleccion() {
        this.setState({ estaSeleccionado: false }, () => {
            console.log('fin arrastre')
        })
    }


    deslizar(direccion, distancia) {

        let posicionDeslizamientoActual = this.carrusel.current.scrollLeft//this.state.posicionDeslizamiento;

        if (!distancia) {
            distancia = 500;
        }
        switch (direccion) {
            case IZQUIERDA:
                posicionDeslizamientoActual -= distancia;
                break;

            case DERECHA:
                posicionDeslizamientoActual += distancia;
                break;
        }
        if (this.carrusel.current) {
            this.carrusel.current.scrollLeft = posicionDeslizamientoActual
        }


    }

    render() {

        let tarjetas = [];

        if (this.props.tarjetas) {
            tarjetas = this.props.tarjetas.map((e, i) => {
                return <TarjetaSinopsis key={i} datos={e} indice={i}
                    indiceSeleccionado={this.state.indiceTarjetaSeleccionada}
                    mostrarTarjetaInfo={(indice)=>{this.setState({indiceTarjetaSeleccionada:indice})}}
                    ocultarTarjetaInfo={(indice)=>{this.setState({indiceTarjetaSeleccionada:null})}}
                />
            })
        }

        return (
            <div className="recomendados" onMouseDown={this.manejarSeleccion} onMouseMove={this.manejarMovimiento}
                onMouseUp={this.manejarDeseleccion} onMouseLeave={this.manejarDeseleccion}>
                <BotonDeslizador direccion={IZQUIERDA} deslizar={this.deslizar} visible={this.mostrarDeslizadorIzquierdo} />
                <div className="encabezado-recomendados">
                    <p>Tus recomendados del día</p>
                    <hr />
                </div>
                <div className="carrusel-recomendados" ref={this.carrusel}>
                    {tarjetas}    
                </div>
                <BotonDeslizador direccion={DERECHA} deslizar={this.deslizar} visible={this.mostrarDeslizadorDerecho} />
            </div>
        )
    }

    componentDidUpdate() {

    }

}

export default Recomendados;